import BuyBookButton from "components/BuyBookButton";

import { PageSerializersBooksShow } from "types/serializers";

export default function BookButtons({
  book,
}: {
  book?: PageSerializersBooksShow;
}) {
  return <BuyBookButton book={book} />;
}
